import { render, staticRenderFns } from "./WebSystemTitleConfig.vue?vue&type=template&id=0b78c802&scoped=true"
import script from "./WebSystemTitleConfig.vue?vue&type=script&lang=js"
export * from "./WebSystemTitleConfig.vue?vue&type=script&lang=js"
import style0 from "./WebSystemTitleConfig.vue?vue&type=style&index=0&id=0b78c802&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b78c802",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b78c802')) {
      api.createRecord('0b78c802', component.options)
    } else {
      api.reload('0b78c802', component.options)
    }
    module.hot.accept("./WebSystemTitleConfig.vue?vue&type=template&id=0b78c802&scoped=true", function () {
      api.rerender('0b78c802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/WebSystemTitleConfig.vue"
export default component.exports